import { Stack, Typography } from "@mui/material";
import TagManagerGrid from "./datagrid/tag-manager-grid";
import { Helmet } from "react-helmet-async";

export default function TagManager() {
  return (
    <>
      <Helmet>
        <title>Cluster Manager</title>
      </Helmet>
      <Stack direction="column" spacing={2} px={"24px"}>
        <TagManagerGrid />
      </Stack>
    </>
  );
}